<template>
  <div :class="classes" @click.prevent=""><slot /></div>
</template>

<script>
export default {
  name: 'NTitle',
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    nowrap: { type: Boolean, default: false },
    /**
     * Functional color. primary, secondary or the like
     */
    fColor: {
      type: String,
      default: 'black',
    },
  },
  computed: {
    classes() {
      return `n-title ${this.nowrap ? 'text-no-wrap' : ' '} ${this.dark ? 'white--text' : this.fColor + '--text'}`;
    },
  },
};
</script>
